import ElstrUserService from "./services/ElstrUserService";

export default class ElstrUser {
  private static reRender: any;

  constructor(reRender) {
    ElstrUser.reRender = reRender;
  }

  public static async logout(): Promise<void> {
    await ElstrUserService.logout();

    this.reRender();
  }
}
